export default __webpack_public_path__ + "static/admin-identity-e4b1be7d9ebe68d4dbe1efc5787c56b3.png";